import React from 'react'
import { useZendesk } from './useZendesk'
import { useSearchParam } from 'react-use'

export { useZendesk } from './useZendesk'

export enum ChatWindowType {
  zendesk,
}

const chatFactory = (type: ChatWindowType) => {
  if (type === ChatWindowType.zendesk) return useZendesk

  throw new Error('Not implemented')
}

export function useChatWindow({ init = true } = {}): { initialize: () => void; toggleShow: () => void } {
  const { toggleShow, initialize } = chatFactory(ChatWindowType.zendesk)()

  React.useEffect(() => {
    //get out when it says don't initialize
    if (!init) return

    initialize()
  }, [init, initialize])

  const showHelpDesk = useSearchParam('show-helpdesk')

  //automatically show the help when it is included on the params
  React.useEffect(() => {
    if (showHelpDesk && showHelpDesk === 'true' && toggleShow) {
      toggleShow()
    }
  }, [showHelpDesk, toggleShow])

  return { toggleShow, initialize }
}
